import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import { PortalApp } from './portal/portal-app.js';
import { SessionProvider } from './session/session-context.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Falta el contenedor #root en index.html');

/**
 * El portal del cliente y el ERP son dos aplicaciones en el mismo paquete.
 *
 * No comparten proveedor de sesión a propósito: un cliente y un empleado
 * no deben poder acabar con la sesión del otro por un descuido de
 * enrutado, y sus tokens llevan audiencias distintas que el servidor
 * comprueba.
 */
const isPortal = window.location.pathname.startsWith('/portal');

createRoot(container).render(
  <StrictMode>
    {isPortal ? (
      <PortalApp />
    ) : (
      <SessionProvider>
        <App />
      </SessionProvider>
    )}
  </StrictMode>,
);
